import React, { forwardRef } from 'react';
import { DatePicker, type DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import EventRoundedIcon from '@mui/icons-material/EventRounded';
import { type Moment } from 'moment';

import "../TextBox/TextBox.scss";

type DateInputProps = Omit<DatePickerProps<Moment>, "inputVariant" | "renderInput"> & {
    error?: boolean;
    helperText?: string;
    onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    disableKeyboardInput?: boolean;
    fullWidth?: boolean;
    required?: boolean;
};

export const DateInput = forwardRef<HTMLDivElement, DateInputProps>(({ error, className, helperText, onBlur, disableKeyboardInput, slotProps, fullWidth, required, ...props}, ref) => (
    <DatePicker
        slots={{
            openPickerIcon: EventRoundedIcon
        }}
        slotProps={{
            ...(slotProps ?? {}),
            openPickerButton: {
                ...(slotProps?.openPickerButton ?? {}),
                size: 'small',
                disableRipple: true,
                style: {
                    color: 'inherit'
                }
            },
            textField: {
                helperText,
                onBlur,
                error,
                fullWidth,
                // @ts-expect-error
                className: `${className} ${slotProps?.textField?.size === 'small' ? '' : 'ms_textbox'}`,
                ...(slotProps?.textField ?? {}),
            },
            field: { 
                readOnly: disableKeyboardInput,
                ...(slotProps?.field ?? {}), 
            },
            inputAdornment: {
                style: {
                    color: 'inherit'
                },
                ...(slotProps?.inputAdornment ?? {}),
            }
        }}
        ref={ref}
        {...props}
        {...(required && { label: `${props.label}*` })}
    />
));
